export default "__VITE_ASSET__b9a55aad__"